import { useCurrentLocale } from '@locales/client';
import { useBrandTheme } from '@/shared/hooks/useBrandTheme';

export const useBannerAssets = (bannerKey: string, ...rest) => {
  const { assets } = useBrandTheme();
  const locale = useCurrentLocale();
  
  const bannerAsset = assets?.[bannerKey];
  
  if (!bannerAsset) {
    return null;
  }
  
  if (typeof bannerAsset === 'function') {
    const currentLocale = locale || 'en';
    return bannerAsset(currentLocale, ...rest) ?? bannerAsset('en');
  }
  

  return bannerAsset;
};